import React, { useState } from 'react';

import RoundResultTable from '../../../result/RoundResultTable';
import { buildRankingTableSections } from './common/rankingTableSections';
import { RESULT_VIEW_STATE } from './common/resultViewModel';
import HitResultContentPC from './pc/HitResultContentPC';
import MissResultContentPC from './pc/MissResultContentPC';
import NotParticipatedResultContentPC from './pc/NotParticipatedResultContentPC';

const resultMessageCardStyle = {
  maxWidth: '520px',
  margin: '24px auto',
  padding: '20px 24px',
  border: '1px solid #d0d7de',
  borderRadius: '16px',
  background: '#f6f8fa',
  textAlign: 'center',
};

const resultMessageTitleStyle = {
  margin: '0 0 8px',
  fontWeight: 700,
  fontSize: '18px',
};

const resultMessageDescriptionStyle = {
  margin: 0,
  lineHeight: 1.7,
  color: '#57606a',
};

const renderMessageCard = ({ dataAttributes = {}, message }) => {
  if (!message) return null;

  return (
    <div {...dataAttributes} style={resultMessageCardStyle}>
      <p style={resultMessageTitleStyle}>{message.title}</p>
      <p style={resultMessageDescriptionStyle}>{message.description}</p>
    </div>
  );
};

const renderResultContent = (viewModel) => {
  switch (viewModel.state) {
    case RESULT_VIEW_STATE.HIT:
      return <HitResultContentPC viewModel={viewModel} />;
    case RESULT_VIEW_STATE.MISS:
      return <MissResultContentPC viewModel={viewModel} />;
    case RESULT_VIEW_STATE.NOT_PARTICIPATED:
      return <NotParticipatedResultContentPC viewModel={viewModel} />;
    case RESULT_VIEW_STATE.NOT_FORMED:
      return renderMessageCard({
        dataAttributes: { 'data-round-not-formed': 'true' },
        message: viewModel.message,
      });
    case RESULT_VIEW_STATE.UNAVAILABLE:
    default:
      return renderMessageCard({
        dataAttributes: { 'data-result-fetch-state': viewModel.fetchState },
        message: viewModel.message,
      });
  }
};

const renderRankingTables = ({ dialogDatas, viewModel }) => {
  const sections = buildRankingTableSections({
    aroundDisplayCount: 10,
    maxDisplayCount: 20,
    ranking: viewModel.ranking,
    topDisplayCount: 10,
  });

  return sections.map((section) => {
    if (section.separator) {
      return (
        <div key={section.key} style={{ textAlign: 'center', fontSize: '24px', lineHeight: 1, color: '#57606a' }}>
          ︙
        </div>
      );
    }

    return (
      <div key={section.key}>
        {section.title ? <h3>{section.title}</h3> : null}
        <RoundResultTable
          currentUserId={viewModel.ranking?.currentUserId}
          dialogDatas={dialogDatas}
          displayMode={section.displayMode}
          displayCount={section.displayCount}
        />
      </div>
    );
  });
};

function MemberResultContentPC({ dialogDatas, viewModel }) {
  const [view, setView] = useState('result');

  return (
    <>
      {view === 'table' ? (
        renderRankingTables({ dialogDatas, viewModel })
      ) : (
        renderResultContent(viewModel)
      )}
      {viewModel.state !== RESULT_VIEW_STATE.UNAVAILABLE ? (
        <div style={{ marginBottom: '10px' }}>
          <button onClick={() => setView('result')} disabled={view === 'result'}>
            ラウンドの結果
          </button>
          <button onClick={() => setView('table')} disabled={view === 'table'}>
            全体結果
          </button>
        </div>
      ) : null}
    </>
  );
}

export default MemberResultContentPC;
